'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _REQUEST_FUNCTION_BY_;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIDialogCloseButton = require('UIComponents/dialog/UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _UIDialogBody = require('UIComponents/dialog/UIDialogBody');

var _UIDialogBody2 = _interopRequireDefault(_UIDialogBody);

var _UIDialogFooter = require('UIComponents/dialog/UIDialogFooter');

var _UIDialogFooter2 = _interopRequireDefault(_UIDialogFooter);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _PromptablePropInterface = require('UIComponents/decorators/PromptablePropInterface');

var _PromptablePropInterface2 = _interopRequireDefault(_PromptablePropInterface);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _requestSeatUpgrade = require('ui-addon-upgrades/_core/upgrade/requestSeatUpgrade');

var _requestAdditionalSeats = require('ui-addon-upgrades/_core/upgrade/requestAdditionalSeats');

var _requestSKU = require('ui-addon-upgrades/_core/upgrade/requestSKU');

var _requestTrial = require('ui-addon-upgrades/_core/upgrade/requestTrial');

var _requestQuotePurchase = require('ui-addon-upgrades/_core/upgrade/requestQuotePurchase');

var _requestProductActivation = require('ui-addon-upgrades/_core/upgrade/requestProductActivation');

var _AdminModalTypes = require('ui-addon-upgrades/_core/common/constants/AdminModalTypes');

var _AdminModalTypes2 = _interopRequireDefault(_AdminModalTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var REQUEST_FUNCTION_BY_TYPE = (_REQUEST_FUNCTION_BY_ = {}, _defineProperty(_REQUEST_FUNCTION_BY_, _AdminModalTypes2.default.REQUEST_ADDITIONAL_SEATS, _requestAdditionalSeats.requestAdditionalSeats), _defineProperty(_REQUEST_FUNCTION_BY_, _AdminModalTypes2.default.REQUEST_SEAT_UPGRADE, _requestSeatUpgrade.requestSeatUpgrade), _defineProperty(_REQUEST_FUNCTION_BY_, _AdminModalTypes2.default.REQUEST_SEAT_UPGRADE_BANNER, _requestSeatUpgrade.requestSeatUpgrade), _defineProperty(_REQUEST_FUNCTION_BY_, _AdminModalTypes2.default.REQUEST_SKU, _requestSKU.requestSKU), _defineProperty(_REQUEST_FUNCTION_BY_, _AdminModalTypes2.default.REQUEST_TRIAL, _requestTrial.requestTrial), _defineProperty(_REQUEST_FUNCTION_BY_, _AdminModalTypes2.default.REQUEST_QUOTE, _requestQuotePurchase.requestQuotePurchase), _defineProperty(_REQUEST_FUNCTION_BY_, _AdminModalTypes2.default.REQUEST_PRODUCT, _requestProductActivation.requestProductActivation), _REQUEST_FUNCTION_BY_);

var AdminModal = function (_Component) {
  _inherits(AdminModal, _Component);

  function AdminModal(props) {
    _classCallCheck(this, AdminModal);

    var _this = _possibleConstructorReturn(this, (AdminModal.__proto__ || Object.getPrototypeOf(AdminModal)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(AdminModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      tracker.track('viewUpgradeAdminPrompt');
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          merchandiseId = _props.merchandiseId,
          modalType = _props.modalType,
          quoteLink = _props.quoteLink,
          onConfirm = _props.onConfirm;

      var requestFunction = REQUEST_FUNCTION_BY_TYPE[modalType];

      if (modalType === _AdminModalTypes2.default.REQUEST_QUOTE) {
        (0, _requestQuotePurchase.requestQuotePurchase)({ quoteLink: quoteLink });
      } else if (requestFunction) {
        var productName = this.getProductName();
        requestFunction({ merchandiseId: merchandiseId, productName: productName });
      }
      onConfirm();
    }
  }, {
    key: 'getProductName',
    value: function getProductName() {
      var merchandiseId = this.props.merchandiseId;

      var productProperties = _ImmutableMerchandiseIdMap2.default[merchandiseId];
      var defaultName = _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.products.default' });

      return productProperties ? productProperties.productName || defaultName : defaultName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          modalType = _props2.modalType,
          onReject = _props2.onReject;


      return _react2.default.createElement(
        _UIModal2.default,
        {
          size: 'auto',
          width: 540,
          use: 'success',
          'data-selenium': 'admin-only-modal',
          onOverlayClick: onReject
        },
        _react2.default.createElement(_UIDialogCloseButton2.default, { onClick: onReject }),
        _react2.default.createElement(
          _UIDialogBody2.default,
          null,
          _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement(_FormattedMessage2.default, {
              message: 'upgrades.adminModal.' + modalType + '.title'
            })
          ),
          _react2.default.createElement(
            'p',
            { className: 'p-right-4' },
            _react2.default.createElement(_FormattedMessage2.default, {
              message: 'upgrades.adminModal.' + modalType + '.paragraph',
              options: {
                productName: this.getProductName()
              }
            })
          )
        ),
        _react2.default.createElement(
          _UIDialogFooter2.default,
          null,
          _react2.default.createElement(
            'div',
            { 'data-selenium': 'admin-modal-close-button' },
            _react2.default.createElement(
              _UIButton2.default,
              {
                className: 'm-left-0',
                use: 'primary',
                onClick: this.handleClick
              },
              _react2.default.createElement(_FormattedMessage2.default, {
                message: 'upgrades.adminModal.' + modalType + '.button'
              })
            )
          )
        )
      );
    }
  }]);

  return AdminModal;
}(_react.Component);

AdminModal.propTypes = _extends({
  merchandiseId: _react.PropTypes.number,
  modalType: _react.PropTypes.oneOf(Object.values(_AdminModalTypes2.default || {})),
  quoteLink: _react.PropTypes.string
}, _PromptablePropInterface2.default);

exports.default = AdminModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/components/AdminModal.js
// module id = 509
// module chunks = 3 4 5